import { createRouter, createWebHashHistory } from 'vue-router';

const routes = [
  { path: '/',          name: 'shift',    component: () => import('../features/shifts/ShiftView.vue') },
  { path: '/log',       redirect: '/' },
  { path: '/history',   redirect: '/planner' },
  { path: '/planner',   name: 'planner',  component: () => import('../features/planner/PlannerView.vue') },
  { path: '/settings/:tab?/:id?', name: 'settings', component: () => import('../features/settings/SettingsView.vue') },
  { path: '/ocr',       name: 'ocr',      component: () => import('@/features/ocr/OcrView.vue') },
];

export const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
